import { BaseModel } from "./baseModel";

export interface Header {
    background: string
}

export interface Avatar {
    background: string
}

export interface ChatContainer {
    right: string
}

export interface Style {
    header?: Header,
    webchatColor?: string,
    avatar?: Avatar,
    chatContainer?: ChatContainer
}

export interface ChannelConfig {
    attributes: Attributes;
    style: Style;
};

export enum Channel {
    webchat = 'webchat',
    webemulator = 'webemulator',
    emulator = 'emulator',
    wabox = 'wabox',
    whatsapp = 'whatsapp'
}

export interface Attributes {
    directLine: string,
    formatOptions: FormatOptions
}

export interface FormatOptions {
    showHeader?: Boolean;
    showTooltip?: Boolean;
    domain?: string;
    avatarOptions?: AvatarOptions;
}

export interface AvatarOptions {
    imageBotAvatar: string;
}

export enum ChannelIdConfig {
    webchat = "webchat",
    webemulator = "webemulator",
    emulator = "emulator",
    wabox = "wabox",
    whatsapp = "whatsapp",
    sms = "sms",
    gupshup = 'whatsapp-gupshup',
    d360 = 'whatsapp-d360',
    whatsweb = "whatsweb",
    liveagent = "live-agent",
    kissbot = "kissbot",
    telegram = "telegram",
    rating = "rating",
    facebook = 'facebook',
    instagram = 'instagram',
    api = 'api',
    campaign = 'campaign',
    confirmation = 'confirmation',
    reminder = 'reminder',
    nps = 'nps', //Net Promoter Score / Pesquisa de satisfação
    medical_report = 'medical_report',
    ads = 'ads', //advertising = anúncio/publicidade/marketing
    api_ivr = 'api_ivr', //IVR/Interactive Voice Response = URA/Unidade de Resposta Audível
    schedule_notification = 'schedule_notification',
}
